import React from 'react';
import useContext from '../../../../hooks/useContext';
import Content from '../../../../styled/Content';
import Distance from '../../../../styled/Distance';
import { ProductContext } from '../providers/ProductProvider';

interface IDescription {
  distance?: string;
}

const Description = ({ distance }: IDescription) => {
  const { configurations, descriptions } = useContext(ProductContext);

  if (!!configurations?.length || !descriptions?.medium) {
    return null;
  }

  return (
    <>
      <Content textAlt>{descriptions.medium}</Content>
      {distance && <Distance size={distance} />}
    </>
  );
};

export default Description;
